import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import rootReducer from './reducers';
import { routingSlice } from './services/routingService';
import { threadSlice } from './services/threadService';
import { formSlice } from './services/formService';

const store = configureStore({
  reducer: rootReducer,
  middleware: [
    ...getDefaultMiddleware({ serializableCheck: false, immutableCheck: false }),
    routingSlice.middleware,
    threadSlice.middleware,
    formSlice.middleware,
  ],
});

export default store;
